import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Wifi } from 'lucide-react'
import { Skeleton } from '@/components/ui/skeleton'

export default function ConnectionStatus() {
  // TODO: 實作連線狀態邏輯
  const isLoading = false

  if (isLoading) {
    return (
      <Card className="h-full">
        <CardHeader className="pb-3">
          <Skeleton className="h-5 w-32" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-4 w-full mb-2" />
          <Skeleton className="h-4 w-3/4" />
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="h-full bg-gradient-to-br from-purple-50 to-purple-100/50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Wifi className="h-4 w-4 text-purple-600" />
          連線狀態
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <p className="text-xs text-gray-600">即將實作...</p>
        </div>
      </CardContent>
    </Card>
  )
}
